interface Props {
    className?: string
}

export default function Arrow({className}: Props) {
    return (<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                 className={className ?? ''}>
        <path d="M10.8002 5.99995H1.2002M1.2002 5.99995L6.0002 10.8M1.2002 5.99995L6.0002 1.19995" stroke="inherit"
              strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>)
}
